/**
 * 全局类型定义
 */

// API响应基础类型
export interface ApiResponse<T = unknown> {
    status: number
    data: T
    message: string
    desc?: string
}

// 分页参数
export interface PageParams {
    page: number
    pageSize: number
}

// 分页响应
export interface PageResponse<T> {
    list: T[]
    total: number
    page: number
    pageSize: number
}

// 选项类型
export interface Option {
    label: string
    value: string | number
}

// 角色标签
export interface MateLabel {
    code: string
    text: string
    color: string
}

// 角色形象详情
export interface MateFigureDetail {
    figure: string
    video: boolean
}

// 角色基础信息项
export interface MateInformation {
    type: string // NICK_NAME, GENDER, AGE, HEIGHT, WEIGHT, BIRTHDAY, NATIONALITY, ALLEGIANCE, RACE
    icon: string
    desc: string
}

// 角色行为档案
export interface MateBehaviorProfile {
    background_detail?: string // 背景补充
    verbal_tics?: string // 口头禅
    likes?: string // 喜欢的事物
    dislikes?: string // 不喜欢的事物
    input_personality?: string // 性格
    bgm?: string // 背景音乐
    appearance?: string // 外貌特点
    attitude_to_user?: string // 对用户的态度
    emoji_preferences?: string // 喜欢的Emoji
    hidden_traits?: string // 隐藏特征
    language_style?: string // 语言风格
    personality?: string[] // 性格标签数组
}

// 角色关系
export interface MateRelationship {
    mate_id: number
    name: string
    figure_images: string[]
    figure_details: MateFigureDetail[]
    figure_type: string
    relationship_name: string
    relationship_desc: string
    relationship_image: string
    relationship_color: string
    relationship_bg_color: string
    has_matched: boolean
    matched_operate?: string
    my_mate_id?: number
}

// 角色详情主体
export interface CharacterProfile {
    mate_id: number
    name: string
    mate_category: string
    figure_type: string
    introduce: string
    lang?: string
    labels: MateLabel[]
    figure_images: string[]
    figure_details: MateFigureDetail[]
    behavior_profile: MateBehaviorProfile
    informations: MateInformation[]
    world_name?: string
    like_count: number
    psy_gender: number
    badge_icon: string
    has_matched: boolean
    relationships?: MateRelationship[], // 可选，可能为空
    design?: string, // 简介
    profile_summary?: string
    prefer_labels?: string[]
}

// new

// Tab类型
export type CharacterTab = 'about' | 'moments' | 'relationships'

// 工具栏类型
export type SideTool = 'image' | 'video'

// 设置类型
export type SettingType =
    | 'text_to_image'
    | 'image_to_image'
    | 'text_to_video'
    | 'image_to_video'
    | 'image_text_translate'
    | 'image_aspect_ratio_converter'
    | 'image_upscaler'
    | 'video_face_swap'
    | 'video_lip_sync'
    | 'remove_video_watermark'
    | 'translate_video_subtitle'
    | 'video_to_anime'
    | 'video_upscaler'
    | 'remove_video_subtitles'
    | 'video_edit'
    | 'video_background_remove'
    | 'video_extender'
    | 'photo_face_swap'
    | 'image_extender'

// 创建图片数据
export interface CreateImageData {
    async?: boolean
    aspect_ratio?: string
    aspect_scale?: string
    audios?: string[]
    almighty_prompt_tokens?: any[]
    almighty_reference_items?: any[]
    characters?: any[]
    credit_workflow_key?: string
    image_number?: number
    image?: string
    images?: string[]
    img_urls?: string[]
    model?: string
    mode?: string
    negative_prompt?: string
    platform?: string
    prompt?: string
    source_type: string
    create_type?: string
    duration?: number
    end_pic_url?: string
    generate_audio?: boolean
    reference_duration?: number
    resolution?: string
    required_credits?: number
    t?: number
    video_model?: string
    video_num?: number
    videos?: string[]
    type?: any
    public_visible?: boolean
    copyright_protection?: boolean
    use_web_search?: boolean
}

// 任务状态枚举
export enum TaskStatus {
    PENDING = 'PENDING',
    PROCESSING = 'PROCESSING',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
    EXCEPTION = 'EXCEPTION',
    TIMEOUT = 'TIMEOUT',
}

// 任务状态响应数据
export interface TaskStatusResponse {
    task_id: string
    status: TaskStatus
    progress?: number
    message?: string
    result?: any
    error?: string
    created_at?: string
    updated_at?: string
}

// 轮询配置选项
export interface PollingOptions {
    interval?: number // 轮询间隔，默认5000ms
    maxAttempts?: number | null // 最大尝试次数，null表示不限制，默认120次（10分钟）
    onProgress?: (status: TaskStatusResponse) => void // 进度回调
    onSuccess?: (result: TaskStatusResponse) => void // 成功回调
    onError?: (error: string) => void // 错误回调
    onTimeout?: () => void // 超时回调
}

// 创建类型枚举
export enum CreateType {
    TEXT_TO_IMAGE = 'text_to_image',
    IMAGE_TO_IMAGE = 'image_to_image',
    TEXT_TO_VIDEO = 'text_to_video',
    IMAGE_TO_VIDEO = 'image_to_video',
}

// 模型类型枚举
export enum ModelType {
    text_to_image = 'textToImgModels',
    image_to_image = 'Image2Image',
    text_to_video = 'text2VideoModels',
    image_to_video = 'Image2Video',
}

// 任务结果详情
export enum resultDetailType {
    text_to_image = 'text_to_img_process',
    image_to_image = 'mask_image_edit_process',
    text_to_video = 'text2_video_process',
    image_to_video = 'img_to_video_process',
    video_edit = 'video_edit_process',
}

export enum ResultDetailToolType {
    FIRST_LAST_IMG_TO_VIDEO = 'img_to_video_process',
}
